import RequireUserMiddleware from 'middlewares/RequireUserMiddleware'
import ForbidSubdomainMiddleware from 'middlewares/ForbidSubdomainMiddleware'
import RoutesEnum from 'enums/routes.enum'

export default [
    {
        path: '/calendar/my/:type',
        name: RoutesEnum.CALENDAR.MY,
        view: 'calendar/MyCalendar',
        middlewares: [RequireUserMiddleware, ForbidSubdomainMiddleware],
        meta: {
            layout: 'main',
            title: 'Moj Kalendar | Bookeraj',
            description:
                'Pregledajte i upravljajte svojim događajima i aktivnostima na svom kalendaru. Planirajte svoje obaveze i budite organizovani.',
        },
    },
]
